import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ChangeCircleSharpIcon from '@mui/icons-material/ChangeCircleSharp';
import { Box, Button, IconButton, Link, Tooltip } from '@mui/material';
import ReviewRecordLinksModal from '../../../../components/ReviewRecordLinksModal/ReviewRecordLinksModal.component';

export default function ReviewRecordLink({ reviewRecordLinks, updateReviewLinks }) {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  let normalizedLinks = [];
  if (Array.isArray(reviewRecordLinks)) {
    normalizedLinks = reviewRecordLinks;
  } else if (reviewRecordLinks) {
    normalizedLinks = [reviewRecordLinks];
  }

  const handleOnSaveModal = async (links) => {
    setIsLoading(true);
    try {
      await updateReviewLinks(links);
      setIsModalOpened(false);
    } catch (error) {
      console.error('Error saving links:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnCloseModal = () => {
    setIsModalOpened(false);
  };

  const onOpenModal = () => {
    setIsModalOpened(true);
  };

  return (
    <>
      {normalizedLinks && normalizedLinks.length > 0 ? (
        <Box p={0.8} display="flex" alignItems="center" flexDirection="column">
          {normalizedLinks.map((link) => (
            <Box key={`record-${link}`} display="flex" alignItems="center" mb={0.5}>
              <Link href={link} target="_blank" rel="noopener" mr={0.5}>
                Record
              </Link>
            </Box>
          ))}
          <Tooltip title="Update records">
            <IconButton onClick={onOpenModal} size="small">
              <ChangeCircleSharpIcon fontSize="medium" />
            </IconButton>
          </Tooltip>
        </Box>
      ) : (
        <Box>
          <Button sx={{ padding: 0 }} onClick={onOpenModal}>
            set record
          </Button>
        </Box>
      )}
      <ReviewRecordLinksModal
        links={normalizedLinks}
        isOpen={isModalOpened}
        onSave={handleOnSaveModal}
        onClose={handleOnCloseModal}
        isSaveLoading={isLoading}
      />
    </>
  );
}

ReviewRecordLink.propTypes = {
  reviewRecordLinks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  updateReviewLinks: PropTypes.func.isRequired,
};

ReviewRecordLink.defaultProps = {
  reviewRecordLinks: null,
};
